import { render, staticRenderFns } from "./AddEtfToPortfolio.vue?vue&type=template&id=201ba51e&scoped=true&"
import script from "./AddEtfToPortfolio.vue?vue&type=script&lang=js&"
export * from "./AddEtfToPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./AddEtfToPortfolio.vue?vue&type=style&index=0&id=201ba51e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201ba51e",
  null
  
)

export default component.exports